<template>
  <div class="mt-2">
    <div class="card p-4 mb-4">
      <div class="h5 font-weight-bold mb-4">Situação Projeto</div>

      <fcc-table
        striped
        hover
        responsive
        :items="situacoesProjeto"
        :fields="fieldsProjeto"
        :optionsButton="optionsProjeto"
        :actions="actionsProjeto"
        pagination
      />
    </div>

    <div class="card p-4">
      <div class="h5 font-weight-bold mb-4">Situação Detalhe</div>

      <fcc-table
        striped
        hover
        responsive
        :items="situacoesDetalhe"
        :fields="fieldsDetalhe"
        :optionsButton="optionsDetalhe"
        :actions="actionsDetalhe"
        pagination
      />
    </div>

    <fccModal
      idModal="modal-situacao"
      :titleModal="titleModal"
      centered
      escondeFooter
      @close="limparForm"
    >
      <b-form @submit.prevent="salvar" autocomplete="off">
        <div class="row mb-4">
          <div class="col"><fcc-input v-model="form.descricao" required>Descrição</fcc-input></div>
        </div>

        <div class="row text-right">
          <div class="col"><fcc-button type="submit">Salvar</fcc-button></div>
        </div>
      </b-form>
    </fccModal>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import { acaoConstantes } from '../constants'
import axios from 'axios'

const situacaoConstantes = {
  PROJETO: 0,
  DETALHE: 1
}

export default {
  data() {
    return {
      itemSelecionado: null,
      form: { descricao: '' },
      situacao: situacaoConstantes.PROJETO,
      acaoModal: acaoConstantes.ADICIONAR,
      fieldsProjeto: [
        { key: 'tpsituacaoprojeto', label: 'Tp Situação Projeto', sortable: true },
        { key: 'descricao', label: 'Descriçao', sortable: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      fieldsDetalhe: [
        { key: 'tpsituacaodetalhe', label: 'Tp Situação Detalhe', sortable: true },
        { key: 'descricao', label: 'Descriçao', sortable: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actionsProjeto: [
        {
          button: true,
          funcaoButton: 'editFieldProjeto',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteFieldProjeto',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      actionsDetalhe: [
        {
          button: true,
          funcaoButton: 'editFieldDetalhe',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteFieldDetalhe',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      optionsProjeto: [
        {
          funcaoButton: 'adicionarProjeto',
          text: 'Adicionar',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      optionsDetalhe: [
        {
          funcaoButton: 'adicionarDetalhe',
          text: 'Adicionar',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['situacoesProjeto', 'situacoesDetalhe']),
    titleModal() {
      const acao = this.acaoModal === acaoConstantes.ADICIONAR ? 'Adicionar ' : 'Editar '
      const situacao = this.situacao === situacaoConstantes.PROJETO ? 'Projeto' : 'Detalhe'
      return acao + situacao
    }
  },
  mounted() {
    this.atualizarItens()
  },
  methods: {
    limparForm() {
      this.form.descricao = ''
    },
    atualizarItens() {
      store
        .dispatch(
          'acompanhamentoDeProjetos/fetchSituacoesProjeto',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() =>
          store.dispatch(
            'acompanhamentoDeProjetos/fetchSituacoesDetalhe',
            this.dadosLoginSession.fccTokenHeaders
          )
        )
        .then(() => this.$emit('carregado'))
        .catch(this.setErrorSystem)
    },
    adicionarProjeto() {
      this.situacao = situacaoConstantes.PROJETO
      this.acaoModal = acaoConstantes.ADICIONAR
      this.$root.$emit('bv::show::modal', 'modal-situacao')
    },
    editFieldProjeto(_, item) {
      this.itemSelecionado = item
      this.form.descricao = item.descricao
      this.situacao = situacaoConstantes.PROJETO
      this.acaoModal = acaoConstantes.EDITAR
      this.$root.$emit('bv::show::modal', 'modal-situacao')
    },
    deleteFieldProjeto(_, item) {
      this.callConfirm('Deseja excluir a situação de projeto?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.situacaoProjetoExcluir(item.tpsituacaoprojeto)
            .then(() => {
              this.carregaTexto()
              this.atualizarItens()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    adicionarDetalhe() {
      this.situacao = situacaoConstantes.DETALHE
      this.acaoModal = acaoConstantes.ADICIONAR
      this.$root.$emit('bv::show::modal', 'modal-situacao')
    },
    editFieldDetalhe(_, item) {
      this.itemSelecionado = item
      this.form.descricao = item.descricao
      this.situacao = situacaoConstantes.DETALHE
      this.acaoModal = acaoConstantes.EDITAR
      this.$root.$emit('bv::show::modal', 'modal-situacao')
    },
    deleteFieldDetalhe(_, item) {
      this.callConfirm('Deseja excluir a situação de detalhe?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.situacaoDetalheExcluir(item.tpsituacaodetalhe)
            .then(() => {
              this.carregaTexto()
              this.atualizarItens()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    salvar() {
      this.callConfirm(
        this.acaoModal === acaoConstantes.ADICIONAR
          ? 'Deseja adicionar uma situação?'
          : 'Deseja editar a situação?',
        ''
      ).then((result) => {
        if (result.value) {
          let methodTipoSistema

          if (this.acaoModal === acaoConstantes.ADICIONAR) {
            methodTipoSistema =
              this.situacao === situacaoConstantes.PROJETO
                ? this.situacaoProjetoAdicionar
                : this.situacaoDetalheAdicionar
          } else {
            methodTipoSistema =
              this.situacao === situacaoConstantes.PROJETO
                ? this.situacaoProjetoAlterar
                : this.situacaoDetalheAlterar
          }

          this.carregaTexto(this.codeMensagem('C01'))
          methodTipoSistema()
            .then(() => {
              this.carregaTexto()
              this.limparForm()
              this.atualizarItens()
              this.$root.$emit('bv::hide::modal', 'modal-situacao')
              this.acaoModal === acaoConstantes.ADICIONAR
                ? this.callToast(this.mensagensUpdate.adicionado)
                : this.callToast(this.mensagensUpdate.editado, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    situacaoProjetoAdicionar() {
      const payload = {
        tpSituacaoProjeto: 0,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.post(
        store.state.baseUrlGestaoProjetos + 'TipoSituacaoProjeto/Adicionar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    situacaoDetalheAdicionar() {
      const payload = {
        tpSituacaoDetalhe: 0,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.post(
        store.state.baseUrlGestaoProjetos + 'TipoSituacaoDetalhe/Adicionar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    situacaoProjetoAlterar() {
      const payload = {
        tpSituacaoProjeto: this.itemSelecionado.tpsituacaoprojeto,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.put(
        store.state.baseUrlGestaoProjetos + 'TipoSituacaoProjeto/Alterar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    situacaoDetalheAlterar() {
      const payload = {
        tpSituacaoDetalhe: this.itemSelecionado.tpsituacaodetalhe,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.put(
        store.state.baseUrlGestaoProjetos + 'TipoSituacaoDetalhe/Alterar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    situacaoProjetoExcluir(tpSitucaoProjeto) {
      return axios.delete(
        store.state.baseUrlGestaoProjetos + 'TipoSituacaoProjeto/Excluir/' + tpSitucaoProjeto,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    situacaoDetalheExcluir(tpSitucaoDetalhe) {
      return axios.delete(
        store.state.baseUrlGestaoProjetos + 'TipoSituacaoDetalhe/Excluir/' + tpSitucaoDetalhe,
        this.dadosLoginSession.fccTokenHeaders
      )
    }
  }
}
</script>